import { useGlobalClickListener } from "../helpers/useGlobalClickListener";
export var GlobalEventsComponent = function () {
    useGlobalClickListener();
    return null;
};
